import moment from 'moment'
import solarLunar from 'solarlunar'

const calendarUtil = {
  createMonthCalendar,
  getCnMonth,
  getCnWeek,
  getFullCnWeek,
  getHoursList,
  setHoliday
}

const holidayMap = [{
  holiday: '元旦',
  time: {
    month: 1,
    day: 1
  },
  // true 公历
  solar: true
}, {
  holiday: '春节',
  time: {
    month: 1,
    day: 1
  },
  solar: false
}, {
  holiday: '劳动节',
  time: {
    month: 5,
    day: 1
  },
  solar: true
}, {
  holiday: '端午节',
  time: {
    month: 5,
    day: 5
  },
  solar: false
}, {
  holiday: '中秋节',
  time: {
    month: 8,
    day: 15
  },
  solar: false
}, {
  holiday: '国庆节',
  time: {
    month: 10,
    day: 1
  },
  solar: true
}, {
  holiday: '妇女节',
  time: {
    month: 3,
    day: 8
  },
  solar: true
}, {
  holiday: '青年节',
  time: {
    month: 5,
    day: 4
  },
  solar: true
}, {
  holiday: '儿童节',
  time: {
    month: 6,
    day: 1
  },
  solar: true
}, {
  holiday: '建军节',
  time: {
    month: 8,
    day: 1
  },
  solar: true
}, {
  holiday: '植树节',
  time: {
    month: 3,
    day: 12
  },
  solar: true
}, {
  holiday: '护士节',
  time: {
    month: 5,
    day: 12
  },
  solar: true
}, {
  holiday: '建党节',
  time: {
    month: 7,
    day: 1
  },
  solar: true
}, {
  holiday: '教师节',
  time: {
    month: 9,
    day: 10
  },
  solar: true
}, {
  holiday: '元宵节',
  time: {
    month: 1,
    day: 15
  },
  solar: false
}, {
  holiday: '北方小年',
  time: {
    month: 12,
    day: 23
  },
  solar: false
}, {
  holiday: '南方小年',
  time: {
    month: 12,
    day: 24
  },
  solar: false
}]
// 将周一设为一周的第一天
moment.locale('cn', {
  weekdaysMin: '一_二_三_四_五_六_日'.split('_'),
  week: {
    dow: 1
  }
})

/**
 * 24小时折分段
 */
function getHoursList () {
  return [
    { label: '00:00', visiable: true },
    { label: '01:00', visiable: true },
    { label: '02:00', visiable: true },
    { label: '03:00', visiable: true },
    { label: '04:00', visiable: true },
    { label: '05:00', visiable: true },
    { label: '06:00', visiable: true },
    { label: '07:00', visiable: true },
    { label: '08:00', visiable: true },
    { label: '09:00', visiable: true },
    { label: '10:00', visiable: true },
    { label: '11:00', visiable: true },
    { label: '12:00', visiable: true },
    { label: '13:00', visiable: true },
    { label: '14:00', visiable: true },
    { label: '15:00', visiable: true },
    { label: '16:00', visiable: true },
    { label: '17:00', visiable: true },
    { label: '18:00', visiable: true },
    { label: '19:00', visiable: true },
    { label: '20:00', visiable: true },
    { label: '21:00', visiable: true },
    { label: '22:00', visiable: true },
    { label: '23:00', visiable: true },
    { label: '24:00', visiable: true }
  ]
}

/**
 * 获取当月视图
 * @param {格式要求：YYYY-MM} startDate
 */
function createMonthCalendar (startDate) {
  let startMoment = startDate ? moment(startDate, 'YYYY-MM') : moment()
  let firstDayOfMonth = startMoment.startOf('month')
  let firstDay = firstDayOfMonth.startOf('week')
  // 日历有7天X6周天
  const DAYS_COUNT = 7 * 6
  let days = []
  let day
  for (let i = 0; i < DAYS_COUNT; i++, firstDay = firstDay.add(1, 'days')) {
    day = solarLunar.solar2lunar(firstDay.get('year'), firstDay.get('month') + 1, firstDay.get('date'))
    day = day === -1 ? {
      cDay: firstDay.get('date'),
      cMonth: firstDay.get('month') + 1,
      cYear: firstDay.get('year')
    } : day
    day.format = firstDay.format('YYYY-MM-DD')
    day.millisecond = firstDay.valueOf()
    day.holiday = []
    day.isHoliday = false
    day.dayType = ''
    day.restType = 0
    setHoliday(day)
    days.push(day)
  }
  return days
}
function setHoliday (day) {
  let month, date
  for (let i = 0; i < holidayMap.length; i++) {
    const holiday = holidayMap[i]
    if (holiday.solar) {
      month = day.cMonth
      date = day.cDay
    } else {
      month = day.lMonth
      date = day.lDay
    }
    if (holiday.time.month === month && holiday.time.day === date) {
      day.isHoliday = true
      day.holiday.push(holiday.holiday)
    }
  }
}
function getCnMonth () {
  return [ '一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月' ]
}
function getCnWeek () {
  return moment.weekdaysMin()
}
function getFullCnWeek (prefix = '周') {
  let weekdays = getCnWeek().map(item => prefix + item)
  return weekdays
}
export default calendarUtil
